import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { CACHE_BUSTING_TOKEN } from './cacheBusting';

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'es',
    nsSeparator: ':::',
    keySeparator: '::', // we use keys in form messages.welcome
    backend: {
      queryStringParams: { v: CACHE_BUSTING_TOKEN }
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;